import { NgxSpinnerService } from 'ngx-spinner';
import { ChartsUtils } from './../../chartsUtils/ChartUtils';
import { FormControl } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { logbaseService } from '../../services/logbase.service';
//import { Key } from 'protractor';
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'app-kpinew',
  templateUrl: './kpinew.component.html',
  styleUrls: ['./kpinew.component.scss']
})
export class KpiNewComponent implements OnInit {
  statusChart: Object;
  statusNewInProgressUnderReveiwChart: Object;
  partChart: Object;
  developmentRatioChart: Object;
  standeardRatioChart: Object;
  standeardRatioSimpleChart: Object;
  getStandardNonStandardLable: any;
   quatrtermodifiedQCharthashchart;
  qchart = {
    "STANDARD_RATIO_LABEL_2": {
      "quarterYear": "Q1 2018",
      "stdFusoAndSupplierPaidRatioMap": {
        "Q1_STANDARD_SUPPLIERPAID_COUNT": 0,
        "Q1_STANDARD_FUSOPAID_COUNT": 0
      }
    },
    "STANDARD_RATIO_LABEL_1": {
      "quarterYear": "Q4 2017",
      "stdFusoAndSupplierPaidRatioMap": {
        "Q4_STANDARD_SUPPLIERPAID_COUNT": 0,
        "Q4_STANDARD_FUSOPAID_COUNT": 0
      }
    },
    "STANDARD_RATIO_LABEL_4": {
      "quarterYear": "Q3 2018",
      "stdFusoAndSupplierPaidRatioMap": {
        "Q3_STANDARD_SUPPLIERPAID_COUNT": 0,
        "Q3_STANDARD_FUSOPAID_COUNT": 0
      }
    },
    "STANDARD_RATIO_LABEL_3": {
      "quarterYear": "Q2 2018",
      "stdFusoAndSupplierPaidRatioMap": {
        "Q2_STANDARD_SUPPLIERPAID_COUNT": 0,
        "Q2_STANDARD_FUSOPAID_COUNT": 0
      }
    }
  }

  stdAndNonStdPackRatio_currentQuarter = {
    "TOTALSUPPLIERPAID": 0,
    "STANDARDSUPPLIERPAID": 0,
    "STANDARDSUPPLIERRATIO": 0,
    "STANDARDFUSOPAID": 0,
    "TOTALFUSOPAID": 0,
    "NONSTANDARDFUSOPAID": 0,
    "STANDARDRATIO": 0,
    "STANDARDFUSORATIO": 0,
    "NONSTANDARDRATIO": 0,
    "NONSTANDARDSUPPLIERPAID": 0,
    "NONSTANDARDFUSORATIO": 0,
    "NONSTANDARDSUPPLIERRATIO": 0,
    "STANDARD": 0,
    "NONSTANDARD": 0,
    "TOTALCOUNT": 0
  }

  partLotSizeNotEqualpartInBox = {
    "Container Type 1": 0
  }

  statusOfPackageId = {
    "NEW": 0,
    "REJECTEDFUSOPAID": 0,
    "APPROVEDSUPPLIERPAID": 0,
    "INPROGRESS": 0,
    "APPROVEDFUSOPAID": 0,
    "REJECTEDSUPPLIERPAID": 0,
    "APPROVED": 0,
    "UNDERREVIEW": 0,
    "REJECTED": 0
  }

  userRoleID: any;
  partlotsize: any;
  suppCode: any;
  suppCodeVal: any;
  suppCodeList: any;
  resstatusstdvsnonstd: any;
  statusstdvsnonstd: any;
  resactivePackagingRequest: any;
  activePackagingRequest: any;
  selecteachItem: any = [];
  selecteachItems: any[] = [];
  selectedItems = [];
  resstandardPackageQuaterRatio: any;
  standardPackageQuaterRatio: any;
  dropdownList = [];
  partswithLotSize: any;
  dropdownSettings: { idField:string;textField:string;singleSelection: boolean; text: string;  enableSearchFilter: boolean; classes: string; badgeShowLimit: number; };

  packageRatioChartsList = {
    packageRatioChartData: [],
    packageRatioChartLabels: [],
    packageRatioChartOptions: {},
    packageRatioChartLegend: false,
    packageRatioChartType: '',
    packageRatiochartColors: {}
  };

  packageSizeChartsList = {
    packageSizeChartData: [],
    packageSizeChartLabels: [],
    packageSizeChartOptions: {},
    packageSizeChartLegend: false,
    packageSizeChartType: '',
    packageSizechartColors: {}
  };

  packageStatusUnderReviewActiveRejectedChartsList = {
    packageUnderReviewActiveRejectedChartData: [],
    packageUnderReviewActiveRejectedChartLabels: [],
    packageUnderReviewActiveRejectedChartOptions: {},
    packageUnderReviewActiveRejectedChartLegend: false,
    packageUnderReviewActiveRejectedChartType: '',
    packageUnderReviewActiveRejectedchartColors: {}
  }

  packageStatusUnderReviewActiveRejectedNonCatChartsList = {
    packageUnderReviewActiveRejectedNonCatChartData: [],
    packageUnderReviewActiveRejectedNonCatChartLabels: [],
    packageUnderReviewActiveRejectedNonCatChartOptions: {},
    packageUnderReviewActiveRejectedNonCatChartLegend: false,
    packageUnderReviewActiveRejectedNonCatChartType: '',
    packageUnderReviewActiveRejectedNonCatchartColors: {}
  }

  packageRatioStandardNonStandardChartsList = {
    ratioStandardNonStandardData: [],
    ratioStandardNonStandardLabels: [],
    ratioStandardNonStandardOptions: {},
    ratioStandardNonStandardLegend: false,
    ratioStandardNonStandardType: '',
    ratioStandardNonStandardColors: {}
  }

  packageRatioStandardNonStandardPackageCodeChartsList = {
    ratioStandardNonStandardPackageCodeData: [],
    ratioStandardNonStandardPackageCodeLabels: [],
    ratioStandardNonStandardPackageCodeOptions: {},
    ratioStandardNonStandardPackageCodeLegend: false,
    ratioStandardNonStandardPackageCodeType: '',
    ratioStandardNonStandardPackageCodeColors: {}
  }

  constructor(private logbaseService: logbaseService,
    private spinner: NgxSpinnerService, private translate: TranslateService
  ) {
    this.getStandardNonStandardLable = ['TTL', this.translate.instant('Fuso Paid'), this.translate.instant('Supplier Paid')];
 
  }
  ngOnInit() {

    let userDetails = localStorage.getItem('userDetails');
    let userDetJson = JSON.parse(userDetails);
    this.userRoleID = userDetJson.userRoleMappings[0].roleId;
    this.suppCodeVal = userDetJson.supplierCode.toString();
    this.suppCodeList = this.suppCodeVal.split(',');
    this.suppCode = this.suppCodeList[0];
    let i = 0;
    for (let key of this.suppCodeList) {
      this.dropdownList.push({ "id": i, "itemName": key });
      i++;
    }

    this.selectedItems = [];
    this.selectedItems = []
    this.dropdownSettings = {
      idField:"id",
      textField:"itemName",
      singleSelection: true,
      text: "Select Supplier Codes",
      enableSearchFilter: true,
      classes: "myclass custom-class",
      badgeShowLimit: 10
    };
  }

  onItemSelect(item) {
    //this.selecteachItem.push(item.itemName);
    this.getAllKpiChart(item.itemName);
  }

  OnItemDeSelect(item: any) {
    // let selected: any = [];
    // if (this.selectedItems.length > 0) {
    //   this.selectedItems.forEach(function (value) {
    //     selected.push(value.itemName);
    //   });
    //   this.getAllKpiChart(selected)
    // } else {
    this.resetKpiData();
    // }
  }

  onSelectAll(items: any) {
    let selectAll: any = [];
    items.forEach(function (value) {
      selectAll.push(value.itemName);
    });
    this.getAllKpiChart(selectAll)
  }
  onDeSelectAll(items: any) {
    let selectAll: any = [];
    if (this.selectedItems.length > 0) {
      items.forEach(function (value) {
        selectAll.push(value.itemName);
      });
      this.getAllKpiChart(selectAll)
    } else {
      this.resetKpiData();
    }

  }

  getAllKpiChart(selectedSupplierCode) {
    this.spinner.show();
    let selectedItem = selectedSupplierCode;
    this.logbaseService.getKPIReportForStandardPackageQuaterRatio(selectedItem).subscribe(result => {
      this.standardPackageQuaterRatio = result;
      this.resstandardPackageQuaterRatio = this.standardPackageQuaterRatio.response;
      this.initPackageRatioChart();

      this.logbaseService.getPartswithLotSize(selectedItem).subscribe(result => {
        this.partswithLotSize = result;
        this.partlotsize = this.partswithLotSize.response;
        this.initPackageSizeChart();

        this.logbaseService.getActivePackagingRequest(selectedItem).subscribe(result => {
          this.activePackagingRequest = result;
          this.resactivePackagingRequest = this.activePackagingRequest.response;
          this.statusUnderReviewActivedRejectedChart(); //3rd Chart 

          this.logbaseService.getStatusStdvsNonstd(selectedItem).subscribe(result => {
            this.statusstdvsnonstd = result;
            this.resstatusstdvsnonstd = this.statusstdvsnonstd.response;
            this.packageRatioStandardNonStandardChart();

            this.logbaseService.getPartswithLotSize(selectedItem).subscribe(result => {
              this.partswithLotSize = result;
              this.partlotsize = this.partswithLotSize.response;
              this.packageRatioTTLStandardNonStandardPackageCodeChart();
              this.spinner.hide();
            })
          })

        })

      })
    });
  }

  initPackageRatioChart() {
    this.packageRatioChartsList.packageRatiochartColors = ChartsUtils.getChartColors()
    this.packageRatioChartsList.packageRatioChartOptions = ChartsUtils.getPackageRatioChartOptions()
    this.packageRatioChartsList.packageRatioChartLegend = ChartsUtils.getBarChartLegend()
    this.packageRatioChartsList.packageRatioChartType = ChartsUtils.getChartTypeBar()
    let tempQchartHash = this.resstandardPackageQuaterRatio
    let modifiedQCharthash = [];
    for (let key in tempQchartHash) {
      if (tempQchartHash.hasOwnProperty(key)) {
        if (Object.keys != null && Object.keys != undefined) {
          let keys1 = Object.keys(tempQchartHash[key].stdFusoAndSupplierPaidRatioMap);
          let values = keys1.map(function (v) { return tempQchartHash[key].stdFusoAndSupplierPaidRatioMap[v]; });
          modifiedQCharthash.push({
            "QUARTERYEAR": tempQchartHash[key].quarterYear,
            "Q1_STANDARD_SUPPLIERPAID_COUNT": values[0],
            "Q1_STANDARD_FUSOPAID_COUNT": values[1]
          })
        }
      }
    }

    let Q1_STANDARD_FUSOPAID = []
    let Q1_STANDARD_SUPPLIERPAID = []
    let QUARTERYEAR = []
    for (let index = 0; index < modifiedQCharthash.length; index++) {
      QUARTERYEAR.push(modifiedQCharthash[index].QUARTERYEAR)
      Q1_STANDARD_SUPPLIERPAID.push(modifiedQCharthash[index].Q1_STANDARD_SUPPLIERPAID_COUNT)
      Q1_STANDARD_FUSOPAID.push(modifiedQCharthash[index].Q1_STANDARD_FUSOPAID_COUNT)
    }
    this.packageRatioChartsList.packageRatioChartLabels = QUARTERYEAR
    this.packageRatioChartsList.packageRatioChartData = [
      { data: Q1_STANDARD_SUPPLIERPAID, label: this.translate.instant('Supplier Paid') },
      { data: Q1_STANDARD_FUSOPAID, label: this.translate.instant('Fuso Paid') }
    ]
  }

  initPackageSizeChart() {
    this.partLotSizeNotEqualpartInBox = this.partlotsize;
    let xAxisCategories = [];
    let seriesData = [];
    for (let key in this.partLotSizeNotEqualpartInBox) {
      if (this.partLotSizeNotEqualpartInBox.hasOwnProperty(key)) {
        xAxisCategories.push(key)
        seriesData.push(this.partLotSizeNotEqualpartInBox[key])
      }
    }
    this.packageSizeChartsList.packageSizechartColors = ChartsUtils.getSetofSingleColor()
    this.packageSizeChartsList.packageSizeChartOptions = ChartsUtils.getLineChartOptions()
    this.packageSizeChartsList.packageSizeChartLegend = ChartsUtils.getBarChartLegend()
    this.packageSizeChartsList.packageSizeChartType = ChartsUtils.getChartTypeHorizontalBar()
    this.packageSizeChartsList.packageSizeChartLabels = xAxisCategories
    this.packageSizeChartsList.packageSizeChartData = [{ data: seriesData, label: 'Container Type' }]

  }

  statusUnderReviewActivedRejectedChart() {
    this.statusOfPackageId = this.resactivePackagingRequest;
    if (this.statusOfPackageId.APPROVEDSUPPLIERPAID == 0) { this.statusOfPackageId.APPROVEDSUPPLIERPAID = null }
    if (this.statusOfPackageId.REJECTEDSUPPLIERPAID == 0) { this.statusOfPackageId.REJECTEDSUPPLIERPAID = null }
    if (this.statusOfPackageId.APPROVEDFUSOPAID == 0) { this.statusOfPackageId.APPROVEDFUSOPAID = null }
    if (this.statusOfPackageId.REJECTEDFUSOPAID == 0) { this.statusOfPackageId.REJECTEDFUSOPAID = null }

    this.packageStatusUnderReviewActiveRejectedChartsList.packageUnderReviewActiveRejectedchartColors = ChartsUtils.getChartColors()
    this.packageStatusUnderReviewActiveRejectedChartsList.packageUnderReviewActiveRejectedChartOptions = ChartsUtils.getLineChartOptionsCustomize()
    this.packageStatusUnderReviewActiveRejectedChartsList.packageUnderReviewActiveRejectedChartLegend = ChartsUtils.getBarChartLegend()
    this.packageStatusUnderReviewActiveRejectedChartsList.packageUnderReviewActiveRejectedChartType = ChartsUtils.getChartTypeBar()
    this.packageStatusUnderReviewActiveRejectedChartsList.packageUnderReviewActiveRejectedChartLabels = ['Approval this Q', 'Rejected this Q']
    this.packageStatusUnderReviewActiveRejectedChartsList.packageUnderReviewActiveRejectedChartData = [
      { data: [this.statusOfPackageId.APPROVEDFUSOPAID, this.statusOfPackageId.REJECTEDFUSOPAID], label: this.translate.instant('Fuso Paid') },
      { data: [this.statusOfPackageId.APPROVEDSUPPLIERPAID, this.statusOfPackageId.REJECTEDSUPPLIERPAID], label: this.translate.instant('Supplier Paid') }]

    this.packageStatusUnderReviewActiveRejectedNonCatChartsList.packageUnderReviewActiveRejectedNonCatchartColors = ChartsUtils.getActiveInProgressUnderReviewColor()
    this.packageStatusUnderReviewActiveRejectedNonCatChartsList.packageUnderReviewActiveRejectedNonCatChartOptions = ChartsUtils.getStatusActiveInProgressUnderReviewOptionWitnPercentage()
    this.packageStatusUnderReviewActiveRejectedNonCatChartsList.packageUnderReviewActiveRejectedNonCatChartLegend = ChartsUtils.getBarChartLegend()
    this.packageStatusUnderReviewActiveRejectedNonCatChartsList.packageUnderReviewActiveRejectedNonCatChartType = ChartsUtils.getChartTypeBar()
    this.packageStatusUnderReviewActiveRejectedNonCatChartsList.packageUnderReviewActiveRejectedNonCatChartLabels = ChartsUtils.getActiveInProgressUnderReviewLabel()
    this.packageStatusUnderReviewActiveRejectedNonCatChartsList.packageUnderReviewActiveRejectedNonCatChartData = [{
      data: [this.statusOfPackageId.NEW, this.statusOfPackageId.INPROGRESS, this.statusOfPackageId.UNDERREVIEW], label: 'Non Categories'
    }];
  }

  packageRatioStandardNonStandardChart() {
    this.stdAndNonStdPackRatio_currentQuarter = this.resstatusstdvsnonstd
    this.packageRatioStandardNonStandardChartsList.ratioStandardNonStandardColors = ChartsUtils.getChartColors()
    this.packageRatioStandardNonStandardChartsList.ratioStandardNonStandardOptions = ChartsUtils.getStatusActiveInProgressUnderReviewOption()
    this.packageRatioStandardNonStandardChartsList.ratioStandardNonStandardLegend = ChartsUtils.getBarChartLegend()
    this.packageRatioStandardNonStandardChartsList.ratioStandardNonStandardType = ChartsUtils.getChartTypeBar()
    this.packageRatioStandardNonStandardChartsList.ratioStandardNonStandardLabels = ChartsUtils.getStandardNonStandardLable()
    this.packageRatioStandardNonStandardChartsList.ratioStandardNonStandardData = [{
      data: [this.stdAndNonStdPackRatio_currentQuarter.STANDARDFUSORATIO + this.stdAndNonStdPackRatio_currentQuarter.STANDARDSUPPLIERRATIO,
      this.stdAndNonStdPackRatio_currentQuarter.STANDARDFUSORATIO,
      this.stdAndNonStdPackRatio_currentQuarter.STANDARDSUPPLIERRATIO], label: 'Standard'
    }, {
      data: [this.stdAndNonStdPackRatio_currentQuarter.NONSTANDARDFUSORATIO + this.stdAndNonStdPackRatio_currentQuarter.NONSTANDARDSUPPLIERRATIO,
      this.stdAndNonStdPackRatio_currentQuarter.NONSTANDARDFUSORATIO,
      this.stdAndNonStdPackRatio_currentQuarter.NONSTANDARDSUPPLIERRATIO], label: 'Non Standard'
    }]
  }

  packageRatioTTLStandardNonStandardPackageCodeChart() {
    this.partLotSizeNotEqualpartInBox = this.partlotsize;
    let xAxisCategories = [];
    let seriesData = [];
    for (let key in this.partLotSizeNotEqualpartInBox) {
      if (this.partLotSizeNotEqualpartInBox.hasOwnProperty(key)) {
        xAxisCategories.push(key)
        seriesData.push(this.partLotSizeNotEqualpartInBox[key])
      }
    }
    this.packageRatioStandardNonStandardPackageCodeChartsList.ratioStandardNonStandardPackageCodeColors = ChartsUtils.getStandardNonStandardPackageCodeColor()
    this.packageRatioStandardNonStandardPackageCodeChartsList.ratioStandardNonStandardPackageCodeOptions = ChartsUtils.getStatusActiveInProgressUnderReviewPackageCodeOption()
    this.packageRatioStandardNonStandardPackageCodeChartsList.ratioStandardNonStandardPackageCodeLegend = false
    this.packageRatioStandardNonStandardPackageCodeChartsList.ratioStandardNonStandardPackageCodeType = ChartsUtils.getChartTypeHorizontalBar()
    this.packageRatioStandardNonStandardPackageCodeChartsList.ratioStandardNonStandardPackageCodeLabels = ChartsUtils.getStatusActiveInProgressUnderReviewPackageCodeLabel()
    this.packageRatioStandardNonStandardPackageCodeChartsList.ratioStandardNonStandardPackageCodeData = [{ data: [this.stdAndNonStdPackRatio_currentQuarter.TOTALCOUNT, this.stdAndNonStdPackRatio_currentQuarter.NONSTANDARD, this.stdAndNonStdPackRatio_currentQuarter.STANDARD], label: 'Pacakge Code' }]
  }

  resetKpiData() {
    this.packageRatioStandardNonStandardPackageCodeChartsList.ratioStandardNonStandardPackageCodeData = [0, 0, 0]
    this.packageRatioStandardNonStandardChartsList.ratioStandardNonStandardData = [{
      data: [0, 0, 0], label: 'Standard'
    }, {
      data: [0, 0, 0], label: 'Non Standard'
    }]
    this.packageRatioChartsList.packageRatioChartData = [{ data: [0, 0, 0], label: this.translate.instant('Supplier Paid') },
    { data: [0, 0, 0], label: this.translate.instant('Fuso Paid') }]
    this.packageStatusUnderReviewActiveRejectedNonCatChartsList.packageUnderReviewActiveRejectedNonCatChartData = [{ data: [0, 0, 0], label: 'Non Categories' }]
    this.packageStatusUnderReviewActiveRejectedChartsList.packageUnderReviewActiveRejectedChartData = [{ data: [0, 0], label: 'Fuso paid' },
    { data: [0, 0], label: this.translate.instant('Supplier Paid') }]
    this.packageSizeChartsList.packageSizeChartData = [{ data: [0, 0, 0, 0], label: 'Container Type' }]
  }
}
